import React from "react";
import "../BodySite.css"
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, NavLink, Navigate } from "react-router-dom";


const EstacionamientoHeader = () => {
    
    return (
        <>
       
       <img src="./estacionamiento-header.png" class="imgTitleMain" ></img>
          
        
        
        </>

    );
    }
export default EstacionamientoHeader;